import { Document, Page } from '@react-pdf/renderer'

import * as React from 'react'
import { Body } from '../../components/body/Body'
import { Content } from '../../components/body/Content'
import styles from '../../components/config'
import { Footer } from '../../components/footer/Footer'
import { PoweredBy } from '../../components/footer/PoweredBy'
import { Header } from '../../components/header/Header'
import { TablePrescriptions } from '../../components/table/Table.prescription'
import { ErrorBoundary } from '../../error-boundary'
import { TDocument } from '../../types'

//
import '../../utils/fonts'

export default function DocTemplate({ doc }: { doc: TDocument }) {
	return (
		<Document
			producer={'medlogix.co.za'}
			pdfVersion={'1.3'}
			creator={'medlogix.co.za'}
			title={'Medlogix'}
			author={'medlogix.co.za'}
			language={'en'}
		>
			<Page style={styles.body} debug={false} orientation={'portrait'} size={'A4'}>
				<ErrorBoundary message={'Error in Header'}>
					<Header doc={doc} />
				</ErrorBoundary>
				<ErrorBoundary message={'Error in Content'}>
					<Content>
						{doc?.documentTemplate === `Prescription` ? (
							<TablePrescriptions medication={doc?.document?.medication} />
						) : null}
						<Body text={doc?.document?.remark} />
					</Content>
				</ErrorBoundary>
				<ErrorBoundary message={'Error in Footer'}>
					<Footer doc={doc} />
				</ErrorBoundary>
				<ErrorBoundary message={'Error in PoweredBy'}>
					<PoweredBy />
				</ErrorBoundary>
			</Page>
		</Document>
	)
}
